import axios from '@/helpers/axios'

const initialState = {
    data: []
}

const mutations = {
    concatData(state, payload = []) {
        state.data = [...state.data, ...payload]
    },
    resetData(state) {
        Object.assign(state, initialState)
    }
}

const actions = {
    async get({ commit }, uuid) {
        const { data: { data } } = await axios.post(`${process.env.VUE_APP_ANNOTATION_REVIEWS_API_URL}/annotations/set_for_grading_by_label/`, {
            data: {
                type: 'annotations',
                attributes: {
                    label_uuid: uuid
                }
            }
        })
        commit('concatData', data)
    },

    async submit(noop, { data }) {
        return await axios.post(`${process.env.VUE_APP_ANNOTATION_REVIEWS_API_URL}/reviews/`, data)
    },

    resetReviews({ commit }) {
        commit('resetData')
    },
}

export default {
    namespaced: true,
    state: { ...initialState },
    actions,
    mutations
}
